<ion-content class="container-conoce-mas-reforma" *ngIf="!loadingHome"  [scrollEvents]="true" >
    <div class="reforma-layout">
        <div class="contentArea">
            <div class="innerContainer">
                <div class="primaryContent">
                <app-header-conoce-mas [seccionActiva]="seccionActiva" (idColumnEmit)="idColumnEmit($event)" class="header"></app-header-conoce-mas>

                <ion-grid class="ion-no-padding" [ngClass]="showErrorScreen ? 'ion-hide' : ''">
                    <ion-row *ngIf="seccionActiva === 'beneficios'" style="width: 100%;">
                        <app-beneficios-reforma-pensiones id="beneficios"
                         style="width: 100%;"></app-beneficios-reforma-pensiones>
                    </ion-row>

                    <ion-row *ngIf="seccionActiva === 'cambios'" style="width: 100%;" >
                        <app-principales-cambios id="cambios" style="width: 100%;"></app-principales-cambios>
                    </ion-row>

                    <ion-row *ngIf="seccionActiva === 'fechas'" style="width: 100%;">
                        <app-fechas-claves id="fechas" [calendarioBeneficios]="calendarioBeneficios"
                            style="width: 100%;"></app-fechas-claves>
                    </ion-row>

                </ion-grid>

                <app-reforma-previsional-content *ngIf="!showErrorScreen"></app-reforma-previsional-content>
                </div>
                <div class="secondaryContent" *ngIf="!showErrorScreen">
                </div>
            </div>
        </div>
    </div>

    <app-help-links *ngIf="!showErrorScreen" class="footer"></app-help-links>
</ion-content>

<ion-content class="container-conoce-mas-reforma" *ngIf="loadingHome && !servsError">
    <div class="contentArea">
        <div class="innerContainer">

            <div class="primaryContent">
                <ion-grid class="ion-no-padding" [ngClass]="showErrorScreen ? 'ion-hide' : ''">
                    <ion-skeleton-text animated style="
            width: 60%;
            height: 25px;
            border-radius: 12px;
            margin-bottom: 23px;
          "></ion-skeleton-text>
                    <ion-skeleton-text animated style="
            width: 90%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 40px;
          "></ion-skeleton-text>

                    <ion-skeleton-text animated style="
            width: 50%;
            height: 24px;
            border-radius: 12px;
            margin-bottom: 3.5px;
          "></ion-skeleton-text>
                    <ion-skeleton-text animated style="
            width: 90%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 48px;
          "></ion-skeleton-text>

                    <ion-skeleton-text animated style="
            width: 65%;
            height: 24px;
            border-radius: 12px;
            margin-bottom: 3.5px;
          "></ion-skeleton-text>
                    <ion-skeleton-text animated style="
            width: 80%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 24px;
          "></ion-skeleton-text>
                </ion-grid>
            </div>
            <div class="secondaryContent" *ngIf="!showErrorScreen">
                <ion-skeleton-text animated style="
            width: 60%;
            height: 25px;
            border-radius: 12px;
            margin-bottom: 23px;
          "></ion-skeleton-text>
                <ion-skeleton-text animated style="
            width: 90%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 40px;
          "></ion-skeleton-text>

                <ion-skeleton-text animated style="
            width: 50%;
            height: 24px;
            border-radius: 12px;
            margin-bottom: 3.5px;
          "></ion-skeleton-text>
                <ion-skeleton-text animated style="
            width: 90%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 48px;
          "></ion-skeleton-text>
            </div>

        </div>
    </div>
</ion-content>


<app-generic-error *ngIf="servsError" [ops]="errorOps" [retryAttempt]="attempt" (retryEvent)="onRetryEvent()"
    (goToEvent)="onGoToEvent()">
</app-generic-error>